import React from 'react'
import Image from "next/image";
import {Container} from 'reactstrap'
import {getImageUrl} from "../../services/image";
import withApollo from "../../lib/withApollo";
import {getDataFromTree} from "@apollo/react-ssr";
import SearchBar from "../../components/Camper/SearchBar";
import Inspiration from "../../components/Camper/Inspiration";
import CamperTypes from "../../components/Camper/CamperTypes";
import USP from "../../components/Camper/USP";

const Index = () => {
    return (
        <React.Fragment>
            <section className="d-flex align-items-center dark-overlay dark-overlay-gradient overflow-none">
                <Image
                    src={getImageUrl('visitscotland_28424747634.jpg')}
                    layout="fill"
                    className="bg-image"
                    alt="Cottage Centre campers"
                    priority={true}
                />

                <Container className="py-md-5 mt-4 text-white z-index-20">
                    <div className="text-center text-lg-left">
                        <p className="subtitle letter-spacing-4 mb-2 text-green-light text-shadow d-none d-lg-block">
                            NATUUR • HISTORIE • CULTUUR
                        </p>
                        <h1 className="font-weight-bold text-shadow homepage-header-h1">
                            Ervaar Groot-Brittannië & Ierland vanuit uw camper
                        </h1>
                    </div>
                    <SearchBar/>
                </Container>
            </section>

            <USP/>

            <CamperTypes/>

            <a
                aria-label="Inspiratie"
                href="/camper#inspiratie"
                className="anchor" id="inspiratie" />
            <Inspiration/>

        </React.Fragment>

    )
}

Index.getInitialProps = async () => {
    return {
        nav: {
            light: true,
            classes: "shadow",
            color: "white",
        },
        title: "Camper verhuur"
    }
}

export default withApollo(Index,
    {
        getDataFromTree
    }
);


